import React, { forwardRef } from 'react'
import cn from 'classnames'
import { WhiteCardPropType } from './WhiteCard.interface'

import './styles.scss'

export const baseClass = 'base-whiteCard-default'

export const WhiteCard: React.FC<WhiteCardPropType> = forwardRef(
  ({ className, renderContent, children, ...props }, ref) => {
    return (
      <div
        className={cn(baseClass, { [className as string]: className })}
        // @ts-ignore
        ref={ref}
        {...props}
      >
        {renderContent ? renderContent() : children}
      </div>
    )
  }
)

export default WhiteCard
